import { Pipe, PipeTransform, Injectable} from '@angular/core';
import { CurrentLangPipe } from './CurrentLangPipe.js';

/**
 * Импорт файлов локализаций
 * Import localization files
 */
import { ru } from '../Translations/ru';
import { en } from '../Translations/en';
import { kk } from '../Translations/kk';

/**
 * Трансформатор перевода ключевых фраз по ключу
 * Translation pipe for key frases by key
 */
@Pipe({
    name: 'translate',
})
export class TranslatePipe implements PipeTransform {
    constructor(private currentLangPipe: CurrentLangPipe) {}
    transform(descriptor: string): string {
        let _lang = {};
        switch (this.currentLangPipe.get()) {
            case 'en': { _lang = en; break; }
            case 'kk': { _lang = kk; break; }
            case 'ru':
            default: { _lang = ru; break; }
        }
        return this.flatten(_lang)[descriptor];
    }

    private flatten(obj: object): object {
        var root: object = {};
        (function tree(obj, index) {
            var suffix: string = toString.call(obj) == "[object Array]" ? "]" : "";
            for(var key in obj) {
                if(!obj.hasOwnProperty(key)) {
                    continue;
                }
                root[index + key + suffix] = obj[key];
                if( toString.call(obj[key]) == "[object Array]" ) {
                    tree(obj[key], index + key + suffix + "[");
                }
                if( toString.call(obj[key]) == "[object Object]" ) {
                    tree(obj[key], index + key + suffix + ".");
                }
            }
        })(obj, "");
        return root;
    }
}